import {
  PanelSection,
  SidePanel,
  Skeleton,
  SkeletonTag,
  SkeletonText,
} from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

type Props = {
  title?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  withClose?: boolean;
  withProgressBox?: boolean;
  onClose?: () => void;
  children?: ReactNode;
};

export function SidePanelLoader({
  header,
  footer,
  title,
  withClose = true,
  withProgressBox = false,
  onClose = () => null,
  children,
}: Props) {
  return (
    <SidePanel
      title={title}
      onClose={withClose ? onClose : undefined}
      header={header}
      footer={footer}
    >
      {children ?? (
        <PanelSection>
          <SkeletonText size="xxl" width="50%" />
          <SkeletonText
            size="xl"
            width="100%"
            className={withProgressBox ? 'my-40' : 'mt-16'}
          />
          {withProgressBox && (
            <>
              <Skeleton height="144px" width="100%" className="mt-40" />
              <SkeletonTag className="mt-24" />
            </>
          )}
        </PanelSection>
      )}
    </SidePanel>
  );
}
